import { render, staticRenderFns } from "./WorldWideListPage.vue?vue&type=template&id=30d48a80&"
import script from "./WorldWideListPage.vue?vue&type=script&lang=js&"
export * from "./WorldWideListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports